
export const experience = [
  {
    title: 'Research Trainee',
    company: 'Computing Research Association',
    period: 'Jun 2026 – Aug 2026',
    description: 'Engaging in an intensive research fellowship focused on academic writing, experimental design, and advanced data analysis in computing.',
    achievements: [
      'Collaborating with research mentors to review state-of-the-art literature and synthesize methodologies for emerging computing challenges.',
      'Strengthening competencies in rigorous research design, quantitative/qualitative data analysis, and ethical research protocols.',
      'Participating in professional development seminars, peer workshops, and mentorship panels led by leading computer science researchers.'
    ]
  },
  {
    title: 'Vice President of Technology',
    company: 'Undergraduate Artificial Intelligence Society (UAIS)',
    period: 'Apr 2026 – Present',
    description: 'Directing technical operations and infrastructure for the university\'s premier AI student organization.',
    achievements: [
      'Orchestrate password management and security protocols for club resources',
      'Manage global GitHub organization and cloud infrastructure on AWS',
      'Governance of Google Workspace (Suite) and public/private data repositories',
      'Lead website maintenance and execute high-priority technical mandates from the President'
    ]
  },
  {
    title: 'AI Engineer',
    company: 'Undergraduate Artificial Intelligence Society (UAIS)',
    period: 'Oct 2025 – Mar 2026',
    description: 'Engineering academic AI tools and data pipelines within the ClubMate initiative.',
    achievements: [
      'Prototyped AI-driven student tools in agile teams for the ClubMate initiative',
      'Architected RAG-based data pipelines and backend integration scripts',
      'Optimized models and demonstration features for technical club workshops'
    ]
  },
  {
    title: 'Software Development Intern',
    company: 'Safe Lanes',
    period: 'Jul 2025 – Aug 2025',
    description: 'Built production-ready features across frontend and backend systems, with an emphasis on clarity and security.',
    achievements: [
      'Delivered a secure PDF viewer with password protection and anti-copy logic',
      'Designed a notification system that scaled to live enterprise workflows',
      'Implemented a retrieval-augmented chatbot using HuggingFace, FAISS, and Streamlit'
    ]
  },
  {
    title: 'Student Body Captain',
    company: 'Fahaheel Al Watanieh Indian Private School (DPS Kuwait)',
    period: 'Sep 2023 – Feb 2024',
    description: 'Led student governance with precision, balancing structure, communication, and results.',
    achievements: [
      'Directed four interhouse competitions and increased participation by 50%',
      'Established peer mentorship practices that reduced incidents by 40%',
      'Guided teams to five interhouse victories with disciplined execution'
    ]
  },
  {
    title: 'Director of Graphic Design',
    company: 'Fahaheel Al Watanieh Indian Private School (DPS Kuwait)',
    period: 'Aug 2023 – Oct 2023',
    description: 'Built editorial systems for print and brand identity with exacting visual language.',
    achievements: [
      'Created magazine covers and layouts with cohesive typographic hierarchy',
      'Increased distribution engagement by 30% through refined design direction',
      'Delivered professional-quality visuals with a 90% satisfaction rating from editors'
    ]
  },
  {
    title: 'Director of Computer Science',
    company: 'Fahaheel Al Watanieh Indian Private School (DPS Kuwait)',
    period: 'Sep 2022 – Mar 2023',
    description: 'Founded and led the Computer Science Club, turning ideas into repeatable programs.',
    achievements: [
      'Grew membership 70% and improved student proficiency in advanced tools',
      'Executed three technical events and four creativity-driven contests',
      'Secured two interschool competition victories with disciplined coaching'
    ]
  }
];

export const education = {
  degree: 'BSc Honours in Computer Science with Artificial Intelligence',
  school: 'University of Alberta',
  period: '2024 – 2028',
  description: 'Studying software engineering, machine learning and systems design through practical projects and research-driven work.'
};

export const skills = [
  {
    category: 'Frontend',
    skills: [
      { name: 'React', level: 95 },
      { name: 'Angular', level: 85 },
      { name: 'Streamlit', level: 90 },
      { name: 'Tailwind CSS', level: 88 }
    ]
  },
  {
    category: 'Backend',
    skills: [
      { name: 'Node.js', level: 92 },
      { name: 'Python', level: 88 },
      { name: 'PostgreSQL', level: 85 },
      { name: 'MongoDB', level: 80 }
    ]
  },
  {
    category: 'Tools & Automation',
    skills: [
      { name: 'Git', level: 95 },
      { name: 'Docker', level: 82 },
      { name: 'N8N', level: 78 },
      { name: 'AWS', level: 75 }
    ]
  }
];

export const philosophy = [
  {
    title: 'Precision in Engineering',
    description: 'Every interface and system should serve a clear functional purpose. If it does not add clarity, it does not belong.'
  },
  {
    title: 'Structure-First Design',
    description: 'I prioritize structural integrity over superficial complexity. The result is software that is robust, maintainable, and predictable.'
  },
  {
    title: 'Durable Solutions',
    description: 'I make technical decisions that hold up under scrutiny and time, focusing on scalability and long-term reliability.'
  }
];

export const socialLinks = {
  github: 'https://github.com/RaghavSethi006',
  linkedin: 'https://www.linkedin.com/in/raghav-sethi-a08501319/'
};

export const email = 'sethi.raghav006@gmail.com';

export const reviews = [
  {
    quote: 'Raghav’s work feels inevitable. He takes a messy requirements brief and delivers a system that is as clear as it is powerful.',
    author: 'Aditi Rao',
    role: 'Product Lead, FinTech'
  },
  {
    quote: 'The attention to structure and detail in his projects makes every feature feel considered and complete.',
    author: 'Nishant Kapoor',
    role: 'Data Science Manager'
  },
  {
    quote: 'He builds tools that don’t just work — they feel like they were designed by someone who understands the problem deeply.',
    author: 'Priya Menon',
    role: 'Operations Director'
  }
];

export const bio = {
  name: 'Raghav Sethi',
  title: 'Software Engineer specializing in AI and Systems Architecture',
  description: 'Specializing in RAG pipelines, full-stack development, and technical infrastructure.',
  highlights: ['AI/ML', 'React', 'Python', 'Node.js', 'SQL', 'Tailwind']
};

export const interests = [
  "Philosophy & Deep Thinking",
  "Strategy / Chess",
  "Ironman / Endurance Athletics",
  "The Intricate Design of Mechanical Watches",
  "Card Magic & Sleight of Hand",
  "Doraemon (The ultimate gadget-based AI)",
  "Gastronomy & Food Exploration",
  "Continuous Knowledge Acquisition & Personal Growth"
];
